// Predefined room tags for discoverability
export const TAG_CATEGORIES = {
  Genre: ['music', 'art', 'photography', 'film', 'gaming', 'comedy', 'horror', 'sci-fi', 'fantasy', 'anime'],
  Mood: ['trippy', 'dark', 'chill', 'energetic', 'peaceful', 'dreamy', 'intense', 'retro', 'futuristic', 'cozy'],
  Style: ['minimalist', 'maximalist', 'abstract', 'realistic', 'surreal', 'neon', 'nature', 'urban', 'vintage', 'cyberpunk'],
  Content: ['gallery', 'showcase', 'interactive', 'music-video', 'portfolio', 'experience', 'game', 'social', 'educational', 'experimental'],
  Other: ['holiday', 'seasonal', 'fan-made', 'collab', 'work-in-progress', 'family-friendly', 'accessible', 'community'],
};

export const MAX_TAGS_PER_ROOM = 4;
